import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { authClient } from "../lib/authClient";
import { EmailOtpAuth } from "../components/auth/EmailOtpAuth";
import { GoogleAuth } from "../components/auth/GoogleAuth";
import { PasskeyAuth } from "../components/auth/PasskeyAuth";
import { SiweAuth } from "../components/auth/SiweAuth";

type AuthMethod = "email-otp" | "google" | "passkey" | "siwe";

export default function LoginPage() {
  const navigate = useNavigate();
  const sessionQuery = authClient.useSession();
  const [activeMethod, setActiveMethod] = useState<AuthMethod>("email-otp");

  useEffect(() => {
    if (sessionQuery.data?.session) {
      navigate("/profile", { replace: true });
    }
  }, [sessionQuery.data?.session, navigate]);

  const authMethods = [
    { id: "email-otp" as AuthMethod, label: "Email OTP", icon: "📧" },
    { id: "google" as AuthMethod, label: "Google", icon: "🔍" },
    { id: "passkey" as AuthMethod, label: "Passkey", icon: "🔐" },
    { id: "siwe" as AuthMethod, label: "Ethereum", icon: "⟠" },
  ];

  return (
    <div className="page-centered">
      <div className="auth-card">
        <h1>Bem-vindo ao wedofi</h1>
        <p className="auth-subtitle">
          Escolha seu método de autenticação preferido
        </p>

        <div className="auth-tabs">
          {authMethods.map((method) => (
            <button
              key={method.id}
              onClick={() => setActiveMethod(method.id)}
              className={`auth-tab ${
                activeMethod === method.id ? "active" : ""
              }`}
            >
              <span className="auth-tab-icon">{method.icon}</span>
              <span className="auth-tab-label">{method.label}</span>
            </button>
          ))}
        </div>

        <div className="auth-content">
          {activeMethod === "email-otp" && <EmailOtpAuth />}
          {activeMethod === "google" && <GoogleAuth />}
          {activeMethod === "passkey" && <PasskeyAuth />}
          {activeMethod === "siwe" && <SiweAuth />}
        </div>
      </div>
    </div>
  );
}
